export default function Footer({ collapsed }) {
  const year = new Date().getFullYear();

  return (
    <div className="fixed bottom-0 left-0 w-full bg-white border-t shadow-sm z-40">
      <footer className="max-w-7xl mx-auto flex items-center justify-between px-4 py-2 text-sm text-gray-500">
        
        <span>© {year} Rayan Info Solutions</span>

        <div className="flex items-center gap-4">
          <a href="https://rayaninfosolutions.com" target="_blank" rel="noopener noreferrer" className="hover:text-blue-600 transition">
            <i className="bi bi-globe-central-south-asia text-xl"></i>
          </a>

          <a href="https://wa.me/+919670796799" target="_blank" rel="noopener noreferrer" className="hover:text-green-600 transition">
            <i className="bi bi-whatsapp text-xl"></i>
          </a>
        </div>
      </footer>
    </div>
  );
}
